<template><div><h1 id="retouren-erfassen" tabindex="-1"><a class="header-anchor" href="#retouren-erfassen"><span>Retouren erfassen</span></a></h1>
<p>Retouren erfassen — Erfasst retournierte Artikel zu Aufträgen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit diesem Job werden die retournierten Artikel erfasst und verwaltet.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Aufträge: → Auftrag → Auftragspositionen (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Auftragsnummer</dt>
<dd>Auftrag zur Retoure</dd>
<dt>Artikel</dt>
<dd>Artikel aus selektierter Auftragsposition (wird vorgeschlagen)</dd>
<dt>Medium</dt>
<dd>Medium gem. Tabelle <a class="link" href="ft.refdata.tblmedium.html" title="Medium">Medium</a> (wird vorgeschlagen wenn ein Medium zu der selektierten Position erfasst ist.</dd>
<dt>Menge</dt>
<dd>Eingabe der retournierten Menge</dd>
<dt>Einzelpreis</dt>
<dd>Stückpreis</dd>
<dt>Rabatt%</dt>
<dd>Rabatt in %</dd>
<dt>Betrag</dt>
<dd>Totalbetrag</dd>
<dt>Fakturanummer</dt>
<dd>wird vorgeschlagen, editierbar</dd>
<dt>Retourcode</dt>
<dd>Codierung für den Grund der Retoure aus Tabelle <a class="link" href="ft.refdata.tblrscode.html" title="Rücksendecodes">Retourcodes</a></dd>
<dt>Wiederverkaufbar</dt>
<dd>Angabe, ob der Artikel wieder verkauft werden kann, resp. ob er wieder in's Lager gebucht wird.</dd>
<dt>Lagerort</dt>
<dd><a class="link" href="ft.refdata.lagerort.html" title="Lagerorte">Lagerort</a>, worin der retournierte Artikel eingelagert wird</dd>
<dt>Zahlungsart</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.systblzahlmod.html" title="Zahlungsmodi">Zahlungsmodi</a></dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>N / A</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Auftragsdaten</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
</div></template>


